import { Stack, Autocomplete, TextField, Typography, IconButton } from "@mui/material";
import { Fragment } from "react";
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

export const PriceForm = ({ formValues, handleInputChange, dataProduct }) => {

    const { rents } = formValues;
    const jsonRents = (typeof rents === 'string') ? JSON.parse(rents) : rents;

    const handleChangeInput = (id, event) => {
        const newInputFields = jsonRents?.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        handleInputChange({ 'target': { 'name': 'rents', 'value': newInputFields } })
    }

    const handleAddFields = () => {
        handleInputChange({ 'target': { 'name': 'rents', 'value': [...jsonRents, { id: uuidv4(), measure: '', size: '', price: '', concept: '', rentsDays: '' }] } })
    }

    const handleRemoveFields = id => {
        const values = [...jsonRents];
        values.splice(values.findIndex(value => value.id === id), 1);
        handleInputChange({ 'target': { 'name': 'rents', 'value': values } })
    }

    return (
        <Stack flexDirection='row' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={4}>
            <Stack width='80%'>
                <Typography textAlign='center' variant="subtitle" color="primary">Alquileres</Typography>
            </Stack>
            {
                jsonRents?.map(inputField => (
                    <Fragment key={inputField.id}>
                        <Stack flexDirection='row' width='80%' gap={2} justifyContent='space-around'>
                            {(dataProduct && inputField) && <Autocomplete
                                options={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).concat('') || ['Cargando productos']}
                                noOptionsText='Elige una opción correcta'
                                fullWidth
                                value={dataProduct?.filter(d => d.type === 'Alquiler').map((d) => d.product).includes(inputField.concept) ? inputField.concept : null}
                                onChange={(event, newValue) => {
                                    handleChangeInput(inputField.id, { target: { name: 'concept', value: newValue || '' } });
                                }}
                                renderInput={(params) => <TextField {...params} label="Concepto" required variant="filled" />}
                            />}
                            <TextField
                                label="Días de alquiler"
                                type="number"
                                variant="filled"
                                name='rentsDays'
                                value={inputField.rentsDays}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { min: 0 } }}
                                required
                            />
                        </Stack>
                        <Stack flexDirection='row' width='80%' justifyContent='space-between' flexWrap='wrap' >
                            <Autocomplete
                                disablePortal
                                options={['m2', 'ud', 'm3', '']}
                                sx={{ width: 130 }}
                                size='small'
                                value={['m2', 'ud', 'm3'].includes(inputField.measure) ? inputField.measure : null}
                                onChange={(event, newValue) => {
                                    handleChangeInput(inputField.id, { target: { name: 'measure', value: newValue || '' } });
                                }}
                                renderInput={(params) => <TextField {...params} label="Unidad" required variant="standard" />}
                            />
                            <TextField
                                sx={{ width: 130 }}
                                label="Tamaño"
                                type="number"
                                variant="standard"
                                size='small'
                                name='size'
                                value={inputField.size}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                required
                            />
                            <TextField
                                sx={{ width: 130 }}
                                label="Precio"
                                type="number"
                                variant="standard"
                                size='small'
                                name='price'
                                value={inputField.price}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                required
                            />
                            <Stack direction='row'>
                                <IconButton disabled={rents.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                                    <DeleteIcon color='primary' />
                                </IconButton>
                                <IconButton
                                    onClick={handleAddFields}
                                >
                                    <AddIcon />
                                </IconButton>
                            </Stack>
                        </Stack>
                    </Fragment>
                ))
            }
        </Stack >
    )
}
